import { Image, Text, View } from "react-native";
import { Plus } from "lucide-react-native";
import { SoftSecondaryButton } from "@louise/moon-ui";
import { GLASS_CARD_STYLE } from "@louise/moon-ui/theme/tokens";
import { useTranslations } from "@src/packages/i18n";
import { EMBER } from "../../../onboarding/theme";

const COST_ESTIMATE_ILLUSTRATION =
  require("../../../assets/images/cost-estimate-coins.png") as number;

type Props = {
  taxYear: number;
  onAddExpense: () => void;
  withCard?: boolean;
};

export default function TaxExpenseEmptyState({
  taxYear,
  onAddExpense,
  withCard = false,
}: Props) {
  const t = useTranslations();

  const content = (
    <>
      <Image
        source={COST_ESTIMATE_ILLUSTRATION}
        accessibilityLabel="Coins illustration"
        resizeMode="contain"
        style={{ width: 76, height: 64, opacity: 0.82 }}
      />
      <Text
        className="font-dm-sans"
        style={{
          fontSize: 14,
          fontWeight: "700",
          color: EMBER.colors.text,
          textAlign: "center",
        }}
      >
        {t("costs.tax_review.payment_records_empty_title")}
      </Text>
      <Text
        className="font-dm-sans"
        style={{
          fontSize: 12,
          lineHeight: 18,
          color: EMBER.colors.textLight,
          textAlign: "center",
        }}
      >
        {t("costs.tax_review.payment_records_empty_body", {
          params: { tax_year: String(taxYear) },
        })}
      </Text>
      <SoftSecondaryButton
        label={t("costs.tax_review.add_expense")}
        onPress={onAddExpense}
        style={{ width: "100%" }}
        leading={
          <Plus size={16} color={EMBER.colors.textMid} strokeWidth={1.8} />
        }
      />
    </>
  );

  return withCard ? (
    <View
      testID="tax-review-empty-expenses"
      style={{
        ...(GLASS_CARD_STYLE as object),
        alignItems: "center",
        gap: 14,
        padding: 28,
      }}
    >
      {content}
    </View>
  ) : (
    <View
      testID="tax-review-empty-expenses"
      style={{ alignItems: "center", gap: 10, paddingVertical: 6 }}
    >
      {content}
    </View>
  );
}
